import React, { useState } from "react";
import AppStoreIcon from "../../../../../Assets/Images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917 1.svg";
import GooglPlayIcon from "../../../../../Assets/Images/WeddinglyAi-Google-Badge.png";

const AppStoreButtons = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", message: "" });

  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    } else if (/huawei/i.test(userAgent)) {
      return "Huawei";
    } else if (/android/i.test(userAgent)) {
      return "Android";
    } else if (/windows phone/i.test(userAgent)) {
      return "WindowsPhone";
    } else {
      return "Other";
    }
  };
  const handleAppleClick = () => {
    const deviceType = detectDevice();
    if (deviceType === "iOS") {
      window.location.assign(
        "https://apps.apple.com/us/developer/weddingly-llc/id1758537679"
      );
    } else {
      showModal(
        "Unsupported Device",
        "It looks like you are not using an iOS device. Please use an Apple device to download from the App Store."
      );
    }
  };
  const handleGoogleClick = () => {
    const deviceType = detectDevice();
    if (deviceType === "Android") {
      window.location.assign(
        "https://play.google.com/store/apps/details?id=com.weddingly.weddinglymobile"
      );
    } else if (deviceType === "Huawei") {
      showModal(
        "Google Play Not Supported",
        "It looks like your device may not support the Google Play Store. Please check the Huawei AppGallery or visit our website for more options."
      );
    } else {
      showModal(
        "Unsupported Device",
        "It looks like you are not using an Android device. Please use an Android device to download from the Google Play Store."
      );
    }
  };
  const showModal = (title, message) => {
    setModalContent({ title, message });
    setModalVisible(true);
  };
  const closeModal = () => {
    setModalVisible(false);
  };
  return (
    <div>
      <div className="download-links">
        <img
          src={AppStoreIcon}
          alt="Apple App Store"
          onClick={handleAppleClick}
          style={{
            height: "40px",
            cursor: "pointer",
          }}
        />
        <img
          src={GooglPlayIcon}
          alt="Google Play Store"
          onClick={handleGoogleClick}
          style={{
            height: "40px",
            cursor: "pointer",
          }}
        />
      </div>
      {modalVisible && (
        <>
          <div
            className="modal-overlay"
            onClick={() => setModalVisible(false)}
          ></div>
          <div className="modal-content">
            <h2>{modalContent.title}</h2>
            <p>{modalContent.message}</p>
            <a href="#" onClick={closeModal}>
              Close
            </a>
          </div>
        </>
      )}
    </div>
  );
};
export default AppStoreButtons;
